async function DesignFolderSave (designfolderid, userid, entryfactorid, velocity, entrysize, notes, modifiedbyid, deleted, referencenum, customerreferencenum, address, materialdetails, elevation) {

    if (
        userid.length > 0 &&
        entryfactorid.length > 0 &&
        modifiedbyid.length > 0 &&
        deleted.length > 0
    ) {

            let response;

            let params = {
                "@DesignFolderId": designfolderid,
                "@UserId": userid,
                "@EntryFactorId": entryfactorid,
                "@Velocity": velocity,
                "@EntrySize": entrysize,
                "@Notes": notes,
                "@ModifiedById": modifiedbyid,
                "@Deleted": deleted,
                "@ReferenceNum": referencenum,
                "@CustomerReferenceNum": customerreferencenum,
                "@Address": address,
                "@MaterialDetails": materialdetails,
                "@Elevation": elevation
            }

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "63", 
                    "parameters": params,
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);
    }
}
 
export default DesignFolderSave;